<template>
    <div>
        <div class="tab">
            <div class="tab-top">
                <div
                    class="l"
                    v-for="(item, index) in select"
                    :key="index"
                    @click="choose(index)"
                    :class="active == index ? 'active' : ''"
                >
                    <img
                        :src="
                            active == index ? item.selectImg : item.selectedImg
                        "
                        alt=""
                    />
                    <div>
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <div class="list" v-if="active == 0">
                <div class="title">
                    <img src="../assets/icon/bg.png" alt="" />
                    <div>开放共享预约系统</div>
                </div>
                <div class="list-li">
                    <div
                        class="li"
                        v-for="(item, index) in share"
                        :key="index"
                        @click="shareSystem(index)"
                    >
                        <img :src="item.img" alt="" />
                        <div>{{ item.text }}</div>
                    </div>
                </div>
            </div>
            <div class="list" v-if="active == 0">
                <div class="title">
                    <img src="../assets/icon/bg.png" alt="" />
                    <div>安全感知预警系统</div>
                </div>
                <div class="list-li" @click="jurisdiction">
                    <div
                        class="li"
                        v-for="(item, index) in perception"
                        :key="index"
                    >
                        <img :src="item.img" alt="" v-if="item.img!=''" />
                        <div>{{ item.text }}</div>
                    </div>
                </div>
            </div>
            <div class="list" v-if="active == 0">
                <div class="title">
                    <img src="../assets/icon/bg.png" alt="" />
                    <div>安全智能管控系统</div>
                </div>
                <div class="list-li">
                    <div
                        class="li"
                        v-for="(item, index) in intelligence"
                        :key="index"
                        @click="jurisdiction"
                    >
                        <img :src="item.img" alt="" v-if="item.img!=''" />
                        <div>{{ item.text }}</div>
                    </div>
                </div>
            </div>
            <div class="list" v-if="active == 0">
                <div class="title">
                    <img src="../assets/icon/bg.png" alt="" />
                    <div>资产管理系统</div>
                </div>
                <div class="list-li">
                    <div
                        class="li"
                        v-for="(item, index) in assets"
                        :key="index"
                        @click="asset(index)"
                    >
                        <img :src="item.img" alt="" v-if="item.img!=''" />
                        <div>{{ item.text }}</div>
                    </div>
                </div>
            </div>
            <div class="mine" v-if="active == 1">
                <div class="ava">
                    <div class="name">{{ information.name }}</div>
                    <div class="work">{{ information.tag_name }}</div>
                </div>
                <div class="bot">
                    <div class="l">
                        <div class="t">预约申请</div>
                        <div class="num">{{ information.order_apply }}</div>
                    </div>
                    <div class="line">|</div>
                    <div class="r">
                        <div class="t">总预约数</div>
                        <div class="num">{{ information.order_total }}</div>
                    </div>
                </div>
            </div>
            <div class="mine-list" v-if="active == 1">
                <router-link to="/changePassword">
                    <div class="li">
                        <img src="../assets/icon/icon_mine_1.png" alt="" />
                        <div>修改密码</div>
                    </div>
                </router-link>
                <div class="li" @click="concat">
                    <img src="../assets/icon/icon_mine_2.png" alt="" />
                    <div>联系管理员</div>
                </div>
                <router-link to="/mine">
                    <div class="li">
                        <img src="../assets/icon/icon_mine_3.png" alt="" />
                        <div>平台介绍</div>
                    </div>
                </router-link>
                <div class="li" @click="cutOff">
                    <img src="../assets/icon/icon_mine_4.png" alt="" />
                    <div>退出登录</div>
                </div>
            </div>
        </div>
        <div style="height:70px;"></div>
        <van-dialog v-model="show" style="width:430px">
            <img
                :src="$global.Image.kefu"
                class="kefu"
                style="width:70px;height:93px;margin:30px 0 17px 0;"
            />
            <div class="txt">请联系管理员</div>
            <div class="mobile">{{ custMobible }}</div>
        </van-dialog>

        <van-dialog
            v-model="close"
            style="width:430px"
            title="退出登录"
            showCancelButton
            confirmButtonColor="#DC3733"
            @confirm="confirm"
        >
            <div class="tr">确认退出登录吗？</div>
        </van-dialog>
    </div>
</template>
<script>
export default {
    name: "navLeftBar",
    props: ["active"],

    data() {
        return {
            show: false,
            close: false,
            information: {},
            select: [
                {
                    selectedImg: require("../assets/icon/icon_home_selected.png"),
                    selectImg: require("../assets/icon/icon_home_select.png"),
                    text: "首页"
                },
                {
                    selectedImg: require("../assets/icon/icon_mine_selected.png"),
                    selectImg: require("../assets/icon/icon_mine_select.png"),
                    text: "个人中心"
                }
            ],
            // active: 0,
            share: [
                {
                    img: require("../assets/icon/icon_share_1.png"),
                    text: "实验室设备预约"
                },
                {
                    img: require("../assets/icon/icon_share_2.png"),
                    text: "实验室设备预约记录"
                },
                {
                    img: require("../assets/icon/icon_share_3.png"),
                    text: "实验室设备预约审批"
                },
                {
                    img: require("../assets/icon/icon_share_4.png"),
                    text: "会议室预约"
                },
                {
                    img: require("../assets/icon/icon_share_2.png"),
                    text: "会议室预约记录"
                },
                {
                    img: require("../assets/icon/icon_share_3.png"),
                    text: "会议室预约审批"
                }
            ],
            perception: [
                {
                    img: require("../assets/icon/icon_gz_1.png"),
                    text: "温度湿度环境监控"
                },
                {
                    img: require("../assets/icon/icon_gz_2.png"),
                    text: "消防烟感环境监控"
                },
                {
                    img: require("../assets/icon/icon_gz_3.png"),
                    text: "气体泄漏环境监控"
                },
                {
                    img: require("../assets/icon/icon_gz_4.png"),
                    text: "漏水环境监控"
                },
                {
                    img: "",
                    text: ""
                },
                {
                    img: "",
                    text: ""
                }
            ],
            intelligence: [
                {
                    img: require("../assets/icon/icon_int_1.png"),
                    text: "视频监控系统"
                },
                {
                    img: require("../assets/icon/icon_int_2.png"),
                    text: "门禁管控系统"
                },
                {
                    img: require("../assets/icon/icon_int_3.png"),
                    text: "空调管控系统"
                },
                {
                    img: require("../assets/icon/icon_int_4.png"),
                    text: "智能电力管控"
                },
                {
                    img: "",
                    text: ""
                },
                {
                    img: "",
                    text: ""
                }
            ],
            assets: [
                {
                    img: require("../assets/icon/icon_assets_1.png"),
                    text: "试验设备信息管理"
                },
                {
                    img: require("../assets/icon/icon_assets_2.png"),
                    text: "试剂耗材管理"
                },
                {
                    img: require("../assets/icon/icon_assets_3.png"),
                    text: "危化品管理"
                },
                {
                    img: require("../assets/icon/icon_assets_4.png"),
                    text: "实验室信息管理"
                },
                {
                    img: require("../assets/icon/icon_assets_4.png"),
                    text: "会议室信息管理"
                },
                {
                    img: "",
                    text: ""
                }
            ],
            custMobible: ""
        };
    },
    methods: {
        choose(e) {
            // this.active = e;
            if (e == 0) {
                this.$router.push("/appointment");
            } else {
                this.$router.push("/mine");
            }
        },
        /**资产管理 */
        asset(index){
            console.log(index)
            // return
            /**实验室设备信息管理 */
            if(index==0){
            this.$router.push("/lab_inform");
            }
            /**实验室信息管理 */
            if(index==3){
            this.$router.push("/equipment_inform");
            }
            /**会议室信息管理 */
            if(index==4){
            this.$router.push("/room_inform");
            }
            if(index==1 || index==2){
            this.$router.push("/jurisdiction");
            }
        },
        concat() {
            this.show = true;
        },
        cutOff() {
            this.close = true;
        },
        confirm() {
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            this.$toast("退出成功");
            setTimeout(() => {
                this.$router.replace("/login");
            }, 1500);
        },

        shareSystem(e) {
            /**实验室设备预约 */
            if (e == 0) {
                this.$router.push("/appointment");
            }
            /**实验室预约记录 */
            if (e == 1) {
                this.$router.push("/record");
            }
            /**实验室预约审批 */
            if (e == 2) {
                this.$router.push("/approval");
            }
            if (e == 3) {
                this.$router.push("/room_appointment");
            }
            if (e == 4) {
                this.$router.push("/room_record");
            }
            if (e == 5) {
                this.$router.push("/room_approval");
            }
        },
        jurisdiction() {
            this.$router.push("/jurisdiction");
        },
        // 联系管理员
        customer() {
            this.$post("/api/login/forget_pass", "")
                .then(res => {
                    this.custMobible = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        userInfo() {
            this.$post("/api/person/index", "").then(res => {
                if (res.code == 1) {
                    this.information = res.data;
                } else {
                }
            });
        }
    },
    mounted() {
        this.customer();
        this.userInfo();
    }
};
</script>
<style lang="less" scoped>
.tr {
    opacity: 0.7;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #999999;
    padding: 20px 0 36px 0;
}
.txt {
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #1c2833;
}
.mobile {
    opacity: 0.7;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #1c2833;
    padding: 27px 0 56px 0;
}
.tab {
    width: 341px;
    background: #ffffff;
    padding-bottom: 135px;
    .tab-top {
        display: flex;
        height: 60px;
        align-items: center;
        .l {
            display: flex;
            width: 50%;
            height: 100%;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #3449d3;
            cursor: pointer;
            img {
                width: 18px;
                height: 20px;
            }
            > div {
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: left;
                color: #3449d3;
                line-height: 25px;
                padding-left: 20px;
            }
        }
        .active {
            background: url("../assets/icon/icon_select_ls.png") no-repeat;
            background-size: 100% 100%;
            > div {
                color: #ffffff;
            }
        }
    }
    .list {
        .title {
            display: flex;
            height: 84px;
            align-items: center;
            img {
                width: 5px;
                height: 24px;
            }
            > div {
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                padding-left: 10px;
            }
        }
        .list-li {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            // justify-content: center;
            padding-left: 11px;
            .li {
                border-left: 1px solid #f8f8f8;
                border-top: 1px solid #f8f8f8;
                width: 106px;
                height: 106px;
                display: flex;
                flex-direction: column;
                // justify-content: center;
                align-items: center;
                cursor: pointer;

                img {
                    width: 41px;
                    height: 40px;
                    margin-top: 13px;
                }
                > div {
                    width: 93px;
                    font-size: 13px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    color: #333333;
                    padding-top: 7px;
                }
            }
            .li:nth-of-type(3n) {
                border-right: 1px solid #f8f8f8;
            }
            .li:nth-of-type(4) {
                border-bottom: 1px solid #f8f8f8;
            }
            .li:nth-of-type(5) {
                border-bottom: 1px solid #f8f8f8;
            }
            .li:nth-of-type(6) {
                border-bottom: 1px solid #f8f8f8;
            }
        }
    }
    .mine {
        width: 308px;
        height: 160px;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.08);
        margin-left: 17px;
        .ava {
            .name {
                font-size: 24px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 600;
                color: #4a4a4a;
                letter-spacing: 0px;
                margin-top: 144px;
                padding-top: 15px;
            }
            .work {
                max-width: 100px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                background: #6480ec;
                border-radius: 13px;
                font-size: 13px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #ffffff;
                letter-spacing: 1px;
                margin: 0 auto;
                margin-top: 4px;
            }
        }
        .bot {
            display: flex;
            height: 66px;
            align-items: center;
            justify-content: space-around;
            border-top: 1px solid #f8f8f8;
            margin-top: 17px;
            .l {
                display: flex;
                flex-direction: column;
                width: 50%;
                .t {
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #999999;
                }
                .num {
                    font-size: 20px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 600;
                    color: #262628;
                    padding-top: 2px;
                }
            }
            .line {
                color: #f5f5f5;
            }
            .r {
                display: flex;
                flex-direction: column;
                width: 50%;
                .t {
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #999999;
                }
                .num {
                    font-size: 20px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 600;
                    color: #262628;
                    padding-top: 2px;
                }
            }
        }
    }
    .mine-list {
        width: 308px;
        .li {
            width: 308px;
            height: 50px;
            background: #ffffff;
            border-radius: 8px;
            box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.08);
            display: flex;
            align-items: center;
            margin-left: 17px;
            margin-bottom: 10px;
            cursor: pointer;
            img {
                width: 22px;
                height: 22px;
                margin-left: 18px;
            }
            > div {
                font-size: 15px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                color: #4a4a4a;
                padding-left: 12px;
            }
        }
        .li:nth-of-type(1) {
            margin-top: 15px;
        }
    }
}
</style>
